var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.devicetype === 10)?_c('span',[_vm._v("mobiltelefon")]):_c('span',[_vm._v("pc")])}
var staticRenderFns = []

export { render, staticRenderFns }